import type { NoticeCalendarEventKind } from "../../utils/noticeCalendarEvents";

export function formatCalendarActivityDate(
  date: Date,
  options?: { includeTime?: boolean }
): string {
  const datePart = date.toLocaleDateString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
  if (!options?.includeTime) {
    return datePart;
  }
  const timePart = date.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${datePart} at ${timePart}`;
}

export function formatCalendarCellTitle(
  fullTitle: string,
  start: Date,
  kind: NoticeCalendarEventKind,
  isMobile: boolean
): string {
  const maxLen = isMobile ? 14 : 22;
  const title =
    fullTitle.length <= maxLen ? fullTitle : `${fullTitle.slice(0, maxLen)}…`;

  if (kind === "publish") {
    const time = start.toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    return `${title} ${time}`;
  }

  return title;
}
